import { buildApiUrl } from '../config';

// Lightweight CSRF helper that keeps the token in memory and
// attaches it to non-GET requests. Avoids localStorage/sessionStorage.
let cachedToken = null;
let inFlight = null;

async function fetchCsrfToken() {
  if (cachedToken) return cachedToken;
  if (inFlight) return inFlight;

  inFlight = fetch(buildApiUrl('/account/csrfToken'), {
    method: 'GET',
    credentials: 'include',
    headers: { accept: 'application/json' },
  })
    .then(async (res) => {
      if (!res.ok) {
        throw new Error(`Failed to fetch CSRF token: ${res.status}`);
      }
      const data = await res.json();
      if (!data?.csrfToken) {
        throw new Error('CSRF token missing in response');
      }
      cachedToken = data.csrfToken;
      return cachedToken;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
}

export function getCsrfToken() {
  return fetchCsrfToken();
}

export function clearCsrfToken() {
  cachedToken = null;
}

export async function csrfFetch(input, init = {}) {
  const method = (init.method || 'GET').toUpperCase();
  const headers = new Headers(init.headers || {});

  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    const token = await fetchCsrfToken();
    headers.set('X-CSRF-Token', token);
  }

  const url = typeof input === 'string' ? buildApiUrl(input) : input;

  return fetch(url, {
    ...init,
    headers,
    credentials: init.credentials || 'include',
  });
}
